import { render, staticRenderFns } from "./ReleaseNoteTagUsageDialog.vue?vue&type=template&id=8cdb6a08"
import script from "./ReleaseNoteTagUsageDialog.vue?vue&type=script&lang=js"
export * from "./ReleaseNoteTagUsageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports